import React from 'react'
import { Link } from 'react-router-dom'
import { History } from 'history'

import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import Intro from '../components/intro'
import CampaignCodeGenerator from '../components/campaign-code-generator'
import CampaignIntroContent from '../components/campaign-intro-content'

interface Props {
  history: History
}

export default function CreateCampaignCodes({
  history,
}: Props): React.ReactElement {
  return (
    <SiteWrapper>
      <Layout width={1200}>
        <Intro title="Create campaign links">
          <CampaignIntroContent type="first-time">
            <p>
              Create campaign links here to help you track and understand
              campaign traffic.{' '}
              <Link to="/track/generator-help">Learn more</Link>.
            </p>
          </CampaignIntroContent>
        </Intro>
        <CampaignCodeGenerator history={history} />
      </Layout>
    </SiteWrapper>
  )
}
